import { useLocation } from 'react-router-dom';

export const useIsEmbeddedView = () => {
  const { search } = useLocation();
  return new URLSearchParams(search).get('mw_context') === 'webview';
};
